import { SearchParams, SearchParamsConfig } from "../../../types/search-types";
import { Plugin } from "..";

class Bedrooms implements Plugin {
  async exec(
    segment: string,
    searchParams: SearchParams,
    _config: SearchParamsConfig,
  ): Promise<SearchParams> {
    if (searchParams.bedrooms) {
      return searchParams;
    }

    // Match patterns like "studio-beds", studio-and-1-beds",  "1-beds", "1-and-2-beds", "1-and-2-and-3-beds" within larger strings
    const regex =
      /(?:^|-)((?:studio|\d{1,2})(?:-and-(?:studio|\d{1,2})){0,9})-beds(?:$|-)/;
    const match = regex.exec(segment);

    if (match) {
      // Extract all numbers from the matched pattern using the captured group
      const bedroomNumbers = match[1]
        .split("-and-")
        .map((bed) => (bed === "studio" ? "0" : bed));
      searchParams.bedrooms = bedroomNumbers;
    }

    return searchParams;
  }
}

export const bedrooms = new Bedrooms();
